import { TipoTopicoNotificacaoEnum, TopicoNotificacao } from 'graphql/types.generated'
import Permissions, { Permission } from 'types/Permissions.generated'

export type NotificacaoCountContextModel = Readonly<Record<TipoTopicoNotificacaoEnum, number>>

export type InscricaoNotificacaoItem = Readonly<
  Pick<
    TopicoNotificacao,
    'id' | 'tipoTopico' | 'codigoTopicoExterno' | 'statusNotificarLido' | 'statusNotificarVisto'
  > & { updatedAt: Instant | null }
>

export type InscricoesTopicosNotificacaoContextModel = Readonly<
  Record<TipoTopicoNotificacaoEnum, Readonly<Record<ID, InscricaoNotificacaoItem>>>
>

export type OperacaoNotificacao = 'SUBSCRIBE' | 'UNSUBSCRIBE' | 'UPDATE'

export interface NotificacaoPubSubResponse {
  readonly timestamp: Instant
  readonly operacao: OperacaoNotificacao
  readonly idTopico: ID
  readonly tipoNotificacao: TipoTopicoNotificacaoEnum
  readonly idRegistroExterno: ID
  readonly notificarVisto: boolean | null
  readonly notificarLido: boolean | null
}

export type NotificacaoPubSubResponseList = ReadonlyArray<NotificacaoPubSubResponse>

export const permissaoPorTipoTopicoNotificacaoRecord: Readonly<Record<TipoTopicoNotificacaoEnum, Permission>> = {
  [TipoTopicoNotificacaoEnum.CUIDADO_COMPARTILHADO]: Permissions.cuidadoCompartilhado,
  [TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL]: Permissions.visualizarProntuario,
}
